<div class="inner-content">
  <div @animatedChatExplainer class="chat-explainer">
    <ion-button class="chat-explainer-close-button animated-button" (click)="dismiss()">
      <ion-icon class="chat-explainer-close-button-icon" src="/assets/custom-icons/b-times.svg"></ion-icon>
    </ion-button>

    <div class="chat-explainer-content" [class.with-footer]="cartItemsCount && !isBrowser">
      <p class="chat-explainer-title animated-title">{{ "VENDOR_CHAT_EXPLAINER_MODAL_PAGE.TITLE" | translate }}</p>
      <p class="chat-explainer-description animated-description">
        <span class="chat-explainer-description-text">{{ "VENDOR_CHAT_EXPLAINER_MODAL_PAGE.DESCRIPTION_FIRST_LINE" | translate }}</span>
        <span class="chat-explainer-description-text">{{ "VENDOR_CHAT_EXPLAINER_MODAL_PAGE.DESCRIPTION_SECOND_LINE" | translate }}</span>
      </p>
      <div class="chat-explainer-illustration animated-illustration"></div>
    </div>
  </div>

  <div tappable class="chat-button expanded" [class.with-footer]="cartItemsCount && !isBrowser">
    <div class="chat-button-icon-container">
      <ion-icon class="chat-button-icon" icon="/assets/custom-icons/whatsapp.svg"></ion-icon>
    </div>
    <div class="chat-button-content">
      <div class="chat-button-text-container animated-text-container">
        <p
          class="chat-button-text visible animated-text"
          [innerHTML]="'VENDOR_CHAT_BUTTON_TEXT' | translate : { vendorName: vendorName }"
        ></p>
      </div>
    </div>
  </div>
</div>
